import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
      text: "",
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        borderDash: [6],
      },
    },
  },
};

const LineChart = (props) => {
  return (
    <Line
      width={window.innerWidth > 450 ? 720 : 300}
      height={window.innerWidth > 450 ? 280 : 166}
      options={options}
      data={props.Data}
    />
  );
};

export default LineChart;
